import React from "react";
import styles from "../../styles/components/product/ProductReviewDigest.module.css";

const ProductReviewDigest = ({ digest, loading }) => {
  if (loading) {
    return (
      <div className={styles.card}>
        <p className={styles.loading}>Analyzing reviews…</p>
      </div>
    );
  }

  if (!digest) return null;

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>AI Review Digest</h3>
      {digest.sentimentSummary && (
        <p className={styles.summary}>{digest.sentimentSummary}</p>
      )}
      <div className={styles.columns}>
        {digest.pros?.length > 0 && (
          <div>
            <h4 className={styles.columnTitle}>Pros</h4>
            <ul className={styles.list}>
              {digest.pros.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}
        {digest.cons?.length > 0 && (
          <div>
            <h4 className={styles.columnTitle}>Cons</h4>
            <ul className={styles.list}>
              {digest.cons.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {digest.priorityNote && (
        <p className={styles.priorityNote}>{digest.priorityNote}</p>
      )}
    </div>
  );
};

export default ProductReviewDigest;
